import { createFileRoute } from "@tanstack/react-router";
import { Assets } from "../../../features/training/assets";

export const Route = createFileRoute("/_authed/$org/$project/assets")({
  validateSearch: (s: Record<string, unknown>): { tab: "models" | "datasets"; q?: string } => ({ tab: s.tab === "datasets" ? "datasets" : "models", q: typeof s.q === "string" ? s.q : undefined }),
  component: AssetsPage,
});

function AssetsPage() {
  const scope = Route.useParams();
  const { tab, q } = Route.useSearch();
  return <Assets scope={scope} tab={tab} query={q} />;
}
